import { getStore } from "../store/Store";
import type { MailLayoutOptions } from "owa-outlook-service-option-store";
import { lazyCreateOrUpdateOptionsForFeature, isOptionsLoaded } from "owa-outlook-service-options";
import { type AnimationPreference, getOptionsForFeature, OwsOptionsFeatureType } from "owa-outlook-service-option-store";
import { setShouldAnimateMutator } from "../mutators/setShouldAnimateMutator";
import { setAnimationPropertiesMutator } from "../mutators/setAnimationPropertiesMutator";

const query = "(prefers-reduced-motion: no-preference)";
const mediaQueryList = window.matchMedia(query);

export function setAnimationPreference(animationPreference: AnimationPreference): void {
    // Get existing settings on server
    const userOptions = getOptionsForFeature<MailLayoutOptions>(OwsOptionsFeatureType.MailLayout);
    
    // Update settings on server if the options aren't loaded or the animation preference is different
    if (!isOptionsLoaded() || userOptions.animationPreference != animationPreference) {
        lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.MailLayout, {
            ...userOptions,
            animationPreference,
        } as MailLayoutOptions);
    }
    
    // Update store
    
    if (animationPreference == 0) {
        mediaQueryList.addListener(handleMotionPreferenceChange);
        setAnimationPropertiesMutator(mediaQueryList.matches, animationPreference);
    }
    else {
        if (getStore().animationPreference == 0) {
            mediaQueryList.removeListener(handleMotionPreferenceChange);
        }
        setAnimationPropertiesMutator(animationPreference == 1, animationPreference);
    }
}

function handleMotionPreferenceChange(this: MediaQueryList) {
    if (this.matches != getStore().shouldAnimate) {
        setShouldAnimateMutator(this.matches);
    }
}
